import React from 'react';
import { Box } from '@mui/material';

const ProfessionalBackground = ({ primaryColor = '#e0e0e0' }) => {
  const patternId = 'subtleWavePattern';
  // Increase pattern size for a larger, less repetitive wave
  const patternSize = 50; // Size of the pattern tile in SVG units
  const strokeWidth = 1; // Thickness of the wave line
  const strokeOpacity = 0.3; // Make it quite subtle

  // Define the wave path - a gentle sine-like curve
  // M moves to start, C defines a Bezier curve
  // Adjust control points (e.g., C10,0 20,20 30,10) to change the wave shape
  const wavePath = `M 0 ${patternSize / 2} C ${patternSize / 4} ${patternSize * 0.1}, ${patternSize * 3 / 4} ${patternSize * 0.9}, ${patternSize} ${patternSize / 2}`;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <svg width="100%" height="100%" style={{ display: 'block' }}>
        <defs>
          <pattern
            id={patternId}
            patternUnits="userSpaceOnUse"
            width={patternSize} // Use the larger pattern size
            height={patternSize} // Use the larger pattern size
          >
            {/* Replace the line with a path for the wave */}
            <path
              d={wavePath}
              stroke={primaryColor}
              strokeWidth={strokeWidth}
              strokeOpacity={strokeOpacity}
              fill="none" // We only want the line, not a filled shape
            />
            {/* Optionally add another wave slightly offset for more texture */}
            <path
              d={wavePath}
              transform={`translate(0, ${patternSize / 4})`}
              stroke={primaryColor}
              strokeWidth={strokeWidth * 0.8} // Slightly thinner
              strokeOpacity={strokeOpacity * 0.7} // Even more subtle
              fill="none"
            />
          </pattern>
        </defs>
        {/* Fill the entire SVG area with the pattern */}
        <rect width="100%" height="100%" fill={`url(#${patternId})`} />
      </svg>
    </Box>
  );
};

export default ProfessionalBackground; 